"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeContractForm = void 0;
const ui_1 = require("@app/component/ui");
const forms_1 = require("@app/component/ui/forms");
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const dropdown_multi_input_1 = require("@app/component/ui/forms/dropdown-multi-input/dropdown-multi-input");
const time_input_1 = require("@app/component/ui/forms/time-input/time-input");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const EmployeeContractForm = ({ control, index, positions, }) => {
    const workspace = (0, store_1.useRootSelector)((state) => state.workspaces.find((w) => w.id === state.workspaceId));
    const baseName = `contracts.${index}`;
    const positionsOptions = positions.map((p) => ({
        label: react_1.default.createElement(ui_1.Position, { pos: p }),
        value: p.id,
    }));
    const localitiesOnWS = workspace?.localities ?? [];
    const localitiesList = localitiesOnWS.map((loc) => {
        return {
            label: react_1.default.createElement(_ui_1.Locality, { ...loc }),
            value: loc?.id,
        };
    });
    const shiftOperationOptions = [
        {
            label: (0, util_1.t)('CONTRACT_OPT_SELECTOPT_singleShift'),
            value: 'singleShift',
        },
        {
            label: (0, util_1.t)('CONTRACT_OPT_SELECTOPT_twoShift'),
            value: 'twoShift',
        },
        {
            label: (0, util_1.t)('CONTRACT_OPT_SELECTOPT_threeShift'),
            value: 'threeShift',
        },
    ];
    const positionsTransfomer = {
        in: (v) => v
            ?.map((p) => positionsOptions.find((po) => po.value === p.positionId))
            .filter(util_1.isDefined) ?? [],
        out: (v) => v
            .map((p) => {
            const tempP = positions.find((po) => po.id === p.value);
            if ((0, util_1.isUndefined)(tempP))
                return undefined;
            return { created: tempP.created, positionId: tempP.id, skill: 0 };
        })
            .filter(util_1.isDefined),
    };
    const localitiesTransformer = {
        in: (v) => v
            ?.map((l) => localitiesList.find((li) => li.value === l.id))
            .filter(util_1.isDefined),
        out: (v) => v
            .map((l) => localitiesOnWS?.find((lows) => lows?.id === l.value))
            .filter(util_1.isValue),
    };
    const contractType = (0, react_hook_form_1.useWatch)({
        control,
        name: `${baseName}.type`,
    });
    const monthHours = (0, react_hook_form_1.useWatch)({
        control,
        name: `${baseName}.options.minutesOfWorkPerMonth`,
    });
    const maxContractHours = react_1.default.useMemo(() => {
        if ((0, util_1.isUndefined)(contractType))
            return 0;
        const _contractType = workspace.contractTypes?.find((ct) => ct.id === contractType);
        const rule = _contractType?.rules.workTimeWeek?.max;
        if ((0, util_1.isUndefined)(rule)) {
            const option = _contractType?.options.minutesOfWorkPerMonth?.default ?? 0;
            return option;
        }
        return rule * 4;
    }, [workspace?.contractTypes, contractType]);
    const isHoursOverMax = react_1.default.useMemo(() => monthHours > maxContractHours && maxContractHours > 0, [monthHours, maxContractHours]);
    return (react_1.default.createElement("div", { style: {
            display: 'grid',
            gridTemplateRows: 'auto',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem',
        } },
        react_1.default.createElement(dropdown_input_1.DropdownInput, { options: workspace.contractTypes?.map((ct) => ({ label: ct.name, value: ct.id })) ??
                [], control: control, name: `${baseName}.type`, label: (0, util_1.t)('CONTRACT_TYPES') }),
        react_1.default.createElement("div", null),
        react_1.default.createElement(time_input_1.TimeInput, { maxHours: 999, disablePicker: true, control: control, name: `${baseName}.options.minutesOfWorkPerMonth`, label: (0, util_1.t)('BATCH_EMPS_CONTRACT_HOURS_MONTH'), error: isHoursOverMax
                ? (0, util_1.t)('EMPLOYEE_CARD_CONTRACT_HOURS_WARNING', {
                    minutes: maxContractHours,
                })
                : undefined }),
        react_1.default.createElement(time_input_1.TimeInput, { disablePicker: true, control: control, name: `${baseName}.options.minutesOfWorkPerShift`, label: (0, util_1.t)('BATCH_EMPS_CONTRACT_HOURS_SHIFT') }),
        react_1.default.createElement(forms_1.DateInput, { label: (0, util_1.t)('BATCH_EMPS_CONTRACT_START'), control: control, name: `contracts.${index}.period.start` }),
        react_1.default.createElement(forms_1.DateInput, { label: 'Konec \u00FAvazku', control: control, name: `${baseName}.period.end` }),
        react_1.default.createElement(dropdown_multi_input_1.DropdownMultiInput, { label: (0, util_1.t)('POSITION'), control: control, name: `${baseName}.positions`, options: positionsOptions, transformer: positionsTransfomer }),
        react_1.default.createElement(dropdown_multi_input_1.DropdownMultiInput, { label: (0, util_1.t)('LOCALITIES_ON_USER'), control: control, name: `${baseName}.localities`, options: localitiesList, transformer: localitiesTransformer }),
        react_1.default.createElement(forms_1.TextInput, { label: (0, util_1.t)('CONTRACT_INDEX'), control: control, name: `${baseName}.contractId` }),
        react_1.default.createElement(dropdown_input_1.DropdownInput, { label: (0, util_1.t)('BATCH_EMPS_CONTRACT_OPERATION'), control: control, name: `${baseName}.options.operation`, options: shiftOperationOptions, sortedOptions: false })));
};
exports.EmployeeContractForm = EmployeeContractForm;
